export enum PagesWithFilterEnum {
  locker = 'LOCKER',
  leaderboard = 'LEADERBOARD'
}
